import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material';
import { GenericDialogProps } from 'utilities/dialog-context/DialogContextHelpers';
import { DialogHeader } from '../dialog/DialogHeader';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@act/storybook';
import {
  HospitalizationDto,
  LearnMoreContentDto,
} from '@act/shared/data-transfer-objects';
import LearnMoreDialogContent from './LearnMoreDialogContent';
import { getDialogContainer } from './utils/DialogContainer';
import { LearnMoreHospitalization } from './learn-more-components/LearnMoreHospitalization';

export interface LearnMoreDialogUniqueProps {
  learnMoreContent?: LearnMoreContentDto;
  hospitalization?: HospitalizationDto;
}

export type LearnMoreDialogProps = GenericDialogProps<boolean> &
  LearnMoreDialogUniqueProps;

export type LearnMoreDialogCallbackInput = {};

const LearnMoreDialog = ({
  learnMoreContent,
  open,
  setOpen,
  hospitalization,
}: LearnMoreDialogProps) => {
  const handleClose = () => {
    setOpen(false);
  };

  const learnMore = hospitalization ? (
    <LearnMoreHospitalization hospitalization={hospitalization} />
  ) : (
    <>
      {!learnMoreContent?.sections?.length && 'Content missing.'}
      {learnMoreContent?.sections.length > 0 && (
        <DialogContentText component="div">
          <LearnMoreDialogContent learnMoreContent={learnMoreContent} />
        </DialogContentText>
      )}
    </>
  );

  const title = hospitalization ? 'Hospitalization' : 'Learn more';

  const container = getDialogContainer();

  return (
    <Dialog
      maxWidth="md"
      open={open}
      onClose={handleClose}
      scroll="body"
      aria-labelledby="assinged-survey-dialog"
      aria-describedby="assigned-survey-dialog"
      role="dialog"
      container={container}
    >
      <DialogHeader
        postfixAction={{
          title: 'close',
          callback: handleClose,
          icon: <CloseIcon />,
        }}
      >
        {title} - {learnMoreContent?.title || 'Content missing'}
      </DialogHeader>
      <DialogContent sx={{ width: '525px', padding: '20px 24px 42px' }}>
        {learnMore}
      </DialogContent>
      <DialogActions
        sx={{
          padding: '16px 24px 8px',
          margin: 'auto 0 8px',
          borderTop: '1px solid #dce4e8',
        }}
      >
        <Button trackingName="learn-more-dialog-button-submit"
          variant="contained"
          type="submit"
          debounced
          onClick={handleClose}
          sx={{ padding: '8px 32px' }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LearnMoreDialog;
